var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-dropdown-divider'),_c('b-dropdown-item',{on:{"click":_vm.resetStock}},[_c('i',{staticClass:"icon-cancel"}),_vm._v(" Resetear Stock a 0 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }